import { useQuery } from '@tanstack/react-query'
import { listAllTimeClocksForCompany } from 'api/admin/timeClock/listAllTimeClocksForCompany'
import { timeClockKeys } from './keys'

export function useAllTimeClocksForCompanyQuery(
  companyId: number | null,
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey:
      companyId === null
        ? timeClockKeys.allForCompany(-1)
        : timeClockKeys.allForCompany(companyId),
    queryFn: () => {
      if (companyId === null) {
        throw new Error('companyId is required')
      }
      return listAllTimeClocksForCompany(companyId)
    },
    enabled: (options.enabled ?? true) && companyId !== null,
  })
}
